<template>
	<div>
		<Header></Header>
		<searchShop :goods="ttshop_goodsxinxi" :store="store.store" ref="searnum"></searchShop>
		<div class="bannershoper" v-if="false"></div>
		<Nav></Nav>
		<!-- 面包屑 -->
		<div class="crumb crumbed" v-if="false">
			<div class="w">
				<div class="nav d-flex align-items-center">
					<div class="nav-item d-flex align-items-center">首页</div>
					<img class="img-default nav-img" src="../../assets/images/rigth.png" alt />
					<dl class="nav-items">
						<dt class="d-flex align-items-center">
							<div>女装</div>
							<img class="img-default nav-xia" src="../../assets/images/top_xia.png" alt />
						</dt>
						<dd class="d-flex flex-wrap">
							<div v-for="item in 25" :key="item">女装</div>
						</dd>
					</dl>
					<img class="img-default nav-img" src="../../assets/images/rigth.png" alt />
					<div class="nav-option d-flex align-items-center">
						品牌：
						<span>菲乐(FELE)</span>
						<span>、</span>
						<span>耐克</span>
						<img class="img-default nav-del" src="../../assets/images/nav_del.png" alt />
					</div>
					<div class="nav-option d-flex align-items-center">
						品牌：
						<span>菲乐(FELE)</span>
						<span>、</span>
						<span>耐克</span>
						<img class="img-default nav-del" src="../../assets/images/nav_del.png" alt />
					</div>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="w">
				<!-- 商品属性 -->
				<div class="goods d-flex justify-content-between">
					<!-- 左边图片 -->
					<div class="goods-l">
						<div class="img">
							<pic-zoom :url="ttshop_goodsxinxi.cover_pic" :scale="1.5"></pic-zoom>
						</div>
						<div class="img-list d-flex justify-content-between align-items-center" :style="{padding: ttshop_goodsxinxi.goods_pic_list.length<=6 ? '0 0': '0 38px'}">
							<div class="swiper-container goods-img swiper-no-swiping">
								<div class="swiper-wrapper">
									<div class="swiper-slide img-item" v-for="(item,index) in ttshop_goodsxinxi.goods_pic_list" :key="index"
									 @mouseenter="enters(item)">
										<img class="img-default" :src="item" alt="" :onerror="errorImg">
									</div>
								</div>
							</div>
							<div class="btn-l swiper-button-prev" v-if="ttshop_goodsxinxi.goods_pic_list.length>6">
								<img class="img-default" src="../../assets/images/img_left.png" alt />
							</div>
							<div class="btn-r swiper-button-next" v-if="ttshop_goodsxinxi.goods_pic_list.length>6">
								<img class="img-default" src="../../assets/images/img_right.png" alt />
							</div>
						</div>

						<div class="goods-l-btn d-flex">
							<template v-if="false">
								<div class="item d-flex align-items-center">
									<div class="item-img"></div>对比
								</div>
								<div class="item d-flex align-items-center">
									<div class="item-img"></div>分享
								</div>
							</template>
						</div>
					</div>
					<!-- 中间 -->
					<div class="goods-c" :style="{'width': look_and_see && look_and_see.length ? '550px':'749px'}">
						<div class="name">{{ttshop_goodsxinxi.name}}</div>
						<div class="name-item">{{ttshop_goodsxinxi.subtitle}}</div>
						<div class="pic">
							<div class="pic-top">
								市场价
								<del>¥ {{ttshop_goodsxinxi.original_price}}</del>
							</div>
							<div class="pic-bottom d-flex align-items-end">
								促销价
								<div class="d-flex integral-price align-items-end">
									<p>{{goods_attr_info.integral || ttshop_goodsxinxi.integral}}</p>
									<span>积分</span>
								</div>
								<template v-if="ttshop_goodsxinxi.price > 0 || ttshop_goodsxinxi.price > 0">
									<span>+</span>
									<div class="price d-flex align-items-end">
										<span>¥</span>
										<p>{{goods_attr_info.price || ttshop_goodsxinxi.price}}</p>
									</div>
								</template>
							</div>
						</div>
						<!-- 优惠券 -->
						<!-- <div class="coupon d-flex align-items-center">
							<div class="coupon-name">优惠券</div>
							<div class="coupon-list d-flex">
								<div class="item d-flex">
									<div class="item-l d-flex justify-content-center align-items-center">¥10</div>
									<div class="item-r d-flex justify-content-center align-items-center">满190减10</div>
								</div>
								<div class="item d-flex">
									<div class="item-l d-flex justify-content-center align-items-center">¥10</div>
									<div class="item-r d-flex justify-content-center align-items-center">满190减10</div>
								</div>
							</div>
							<div class="coupon-btn" @click="dialogFormVisible = true">共3张优惠券></div>
						</div> -->
						<!-- 促销 -->
						<div class="rush d-flex align-items-center">
							<div class="rush-name">促销</div>
							<div class="rush-list d-flex flex-wrap">
								<div class="item d-flex justify-content-center align-items-center" v-for="(item,index) in ttshop_goodsxinxi.service_list"
								 :key="index">{{item}}</div>
							</div>
						</div>
						<!-- 尺码 -->
						<div class="size d-flex align-items-center" v-for="(item,index) in attr_group_list" :key="index">
							<div class="size-name">{{item.attr_group_name}}</div>
							<div class="size-list d-flex flex-wrap flex_1">
								<div v-for="(items,index) in item.attr_list" :key="index">
									<div class="items d-flex justify-content-center align-items-center" v-if="items.attr_num_0">
										{{items.attr_name}}
									</div>
									<div class="item d-flex justify-content-center align-items-center" @click="sizeClick(item.attr_group_id,items.attr_id)"
									 :class="{size_active: items.active == true}" v-else>
										{{items.attr_name}}
										<div class="pitc" v-if="items.active">
											<img class="img-default" src="../../assets/images/brand.png" alt />
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- 按钮 -->
						<div class="btn d-flex align-items-center">
							<div class="btn-buy d-flex justify-content-center align-items-center" @click="goodsSubmit()">立即兑换</div>
							<div class="btn-phone d-flex align-items-center justify-content-center" v-if="false">
								<div class="btn-phone-l"><img class="img-default" src="../../assets/images/cat_white.png" alt /></div>
								手机购买
								<div class="btn-phone-r">
									<img class="img-default" src="../../assets/images/bottom_14.png" alt />
								</div>
								<div class="btn-phone-qr">
									<div class="btn-phone-img"></div>
								</div>
							</div>
						</div>
					</div>
					<!-- 右边 -->
					<div class="goods-r" v-if="look_and_see && look_and_see.length">
						<div class="title d-flex align-items-center">
							<span></span>
							<div class="txt">看了又看</div>
							<span></span>
						</div>
						<div class="swiper-container list goods-look">
							<div class="swiper-wrapper">
								<template v-for="(item,index) in look_and_see">
									<div class="item swiper-slide" @click="toGoods(item.id)">
										<img class="img-default" :src="item.cover_pic" alt />
										<div class="pic d-flex align-items-center justify-content-center" v-text="'¥'+item.price"></div>
									</div>
								</template>
							</div>
						</div>
						<div class="btn d-flex justify-content-center align-items-center">
							<div class="btn-top swiper-button-prev">
								<img class="img-default" src="../../assets/images/img_left.png" alt />
							</div>
							<div class="btn-bottom swiper-button-next">
								<img class="img-default" src="../../assets/images/img_left.png" alt />
							</div>
						</div>
					</div>
				</div>
				<!-- 商品详情 -->
				<div class="details d-flex justify-content-between">
					<!-- 左边 -->
					<div class="details-l">
						<div class="shop">
							<div class="shop-title d-flex justify-content-between align-items-center">
								<div class="title-l">商家</div>
								<div class="title-r d-flex align-items-center" v-if="false">
									<div class="img-r">
										<img class="img-default" src="../../assets/images/xcx.png" alt />
									</div>
									<div class="img-c">小程序店铺</div>
									<div class="img-l">
										<img class="img-default" src="../../assets/images/bottom_14.png" alt />
									</div>
								</div>
							</div>
							<div class="shop-name show-one-lines">商家：平台自营</div>
							<div class="shop-tel show-one-lines" v-if="contact_tel">电话：{{contact_tel}}</div>
							<div class="shop-kf d-flex align-items-center" v-if="store_option.web_service_status == 1 && store_option.web_service_url"
							 @click="webService()">
								联系：
								<img class="img-default kf-img" src="../../assets/images/service.png" alt /> 在线客服
							</div>
							<div class="shop-tel show-one-lines"></div>
						</div>
					</div>
					<!-- 右边 -->
					<div class="details-r">
						<div class="details-r-box">
							<div class="tab d-flex">
								<div class="tab-item" @click="detailsClick(0)" :class="{details_active: 0 ==detailsIndex}">商品详情</div>
								<div class="tab-item tab-itemeds" @click="detailsClick(1)" :class="{details_active: 1 ==detailsIndex}">商品评价（{{evaluateTab.score_all}}）</div>
								<div class="mobile d-flex align-items-center" v-if="false">
									<div class="mobile-l"></div>
									<div class="mobile-c">手机购买</div>
									<div class="mobile-r">
										<img class="img-default" src="../../assets/images/bottom_14.png" alt />
									</div>
									<div class="mobile-hidden">
										<div class="mobile-hidden-img"></div>
									</div>
								</div>
								<div class="btn" @click="goodsSubmit()" style="margin-left: auto;">立即兑换</div>
							</div>
							<!-- 详情 -->
							<div class="conter" v-if="detailsIndex == 0">
								<div class="conter-img" v-html="ttshop_goodsxinxi.detail"></div>
							</div>
							<!-- 评价 -->
							<div class="evaluate" v-if="detailsIndex == 1">
								<div class="evaluate-tab d-flex align-items-center" v-if="evaluateTab.score_all!= 0">
									<div class="evaluate-num">
										<div class="num">
											{{ttshop_goodsxinxi.good_rate}}
											<span>%</span>
										</div>
										<div class="txt">好评率</div>
									</div>
									<div class="tab-list d-flex">
										<div class="tab-item" :class="{tab_item_avtive:score == 0}" @click="scoreTab(0)">全部({{evaluateTab.score_all}})</div>
										<div class="tab-item" :class="{tab_item_avtive:score == 3}" @click="scoreTab(3)">好评({{evaluateTab.score_3}})</div>
										<div class="tab-item" :class="{tab_item_avtive:score == 2}" @click="scoreTab(2)">中评({{evaluateTab.score_2}})</div>
										<div class="tab-item" :class="{tab_item_avtive:score == 1}" @click="scoreTab(1)">差评({{evaluateTab.score_1}})</div>
										<div class="tab-item" :class="{tab_item_avtive:score == 4}" @click="scoreTab(4)">有图({{evaluateTab.score_4}})</div>
									</div>
								</div>
								<div class="evaluate-item d-flex align-items-start" v-for="(item,index) in evaluateList" :key="index" v-show="evaluateList !=''">
									<div class="user-l align-items-center d-flex">
										<div class="user-img"><img class="img-default" :src="item.avatar_url" alt=""></div>
										<div class="user-name">{{item.nickname}}</div>
									</div>
									<div class="evaluate-item-r">
										<div class="star-list d-flex">
											<div class="star-img" v-for="items in Number(item.score_star)" :key="items">
												<img class="img-default" src="../../assets/images/star.png" alt />
											</div>
										</div>
										<p class="txt">{{item.content}}</p>
										<div class="img-list d-flex">
											<div class="img" v-for="(items,idx) in item.pic_list" :key="idx">
												<img class="img-default" :src="items" alt="">
											</div>
										</div>
										<div class="time">
											{{item.addtime}}
										</div>
									</div>
								</div>
								<div class="evaluate-item d-flex align-items-center justify-content-center" v-show="evaluateList ==''">
									暂无评价
								</div>
							</div>
						</div>
						<div class="page d-flex justify-content-end" v-if="detailsIndex == 1">
							<el-pagination background @current-change="handleCurrentChange" @prev-click="pages_perv" @next-click="page_next"
							 :page-size="limit" layout="prev, pager, next" :total="Number(row_count)" :hide-on-single-page="singlePage"></el-pagination>
						</div>
						<div class="ttshop_qitashop" v-if="best_goods_list && best_goods_list.length">
							<!-- 其他商品 -->
							<div class="rest-title">其他商品</div>
							<!-- 商品列表 -->
							<div class="rest-list d-flex flex-wrap">
								<template v-for="(item,index) in best_goods_list">
									<div class="rest-item d-flex justify-content-between flex-direction-column" @click="toGoods(item.id)">
										<div class="rest-img"><img class="img-default" :src="item.cover_pic" alt=""></div>
										<div class="rest-name" v-text="item.name"></div>
										<div class="rest-pic d-flex justify-content-between align-items-end">
											<div class="pic-l">
												<span>¥</span> {{item.price}}
											</div>
											<div class="pic-r" v-if="false"><span>540+</span> 评价</div>
										</div>
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="优惠券" :visible.sync="dialogFormVisible">
			<div class="coupon-tab d-flex">
				<div class="coupon-tab-item" @click="couponTab(0)" :class="{coupon_active: 0 == couponIndex}">可领取优惠券</div>
				<div class="coupon-tab-item" @click="couponTab(1)" :class="{coupon_active: 1 == couponIndex}">已领取优惠券</div>
			</div>
		</el-dialog>
		<Foot></Foot>
		<sidebar ref="sidebars" @parentFn="childTreeFn" :goodsId="ttshop_goodsxinxi.id"></sidebar>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Foot from "@/components/foot/foot";
	import searchShop from "@/components/search/searchShop";
	import Nav from "@/components/nav/nav";
	import sidebar from "@/components/sidebar/sidebar";
	import "./integral.css";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import PicZoom from 'vue-piczoom'
	export default {
		components: {
			Header,
			Foot,
			searchShop,
			Nav,
			sidebar,
			PicZoom
		},
		data() {
			return {
				num: 1, //购物车数量
				detailsIndex: 0,
				sizeIndex: 0,
				colorIndex: 0,
				couponIndex: 0,
				datatype: false,
				dialogTableVisible: false,
				dialogFormVisible: false,
				id: this.$route.query.id, //商品id
				ttshop_goodsxinxi: {
					goods_pic_list: [],
					cover_pic: '',
				}, //商品信息
				ttshop_kucun: [], //商品库存
				ttshop_kcnum: 1,
				errorImg: 'this.src="' + require("../../assets/images/lodingsb.svg") + '"', //图片加载失败
				goods_attr_info: {},
				evaluateList: [],
				evaluateTab: [],
				score: 0,
				page: 1,
				limit: 5,
				page_count: "",
				row_count: "",
				singlePage: true,
				video_show: false,
				autoplay: "",
				customer_service: null,
				store: {},
				contact_tel: '',
				store_option: {},
				look_and_see: [], //看了又看
				best_goods_list: [], //其他商品
				attr_group_list: [], //属性
			};
		},
		created() {
			window.sessionStorage.setItem('alipay_type', ''); //清除支付宝支付状态
			this.shopgoodsapi();
			this.commentList();
			this.getStore();
		},
		mounted() {

		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.query.id != from.query.id) {
					this.id = to.query.id;
					this.shopgoodsapi();
					this.commentList();
					this.detailsIndex = 0;
				}
			},
		},
		methods: {
			// 获取商城配置
			getStore() {
				this.$api.store({}).then((res) => {
					this.contact_tel = res.data.contact_tel;
					this.store_option = res.data.store.option;
					this.store = res.data;
				}).catch((err) => {
					console.log(err);
				});
			},
			// 平台客服
			webService(type) {
				let goods = this.ttshop_goodsxinxi;
				let store = this.store.store;
				let customer_service = this.customer_service;
				if (this.$store.state.user) {
					if (this.$store.state.user.token != "") {
						let url_str = this.common.webService(this, goods, store, type, customer_service);
						window.open(url_str);
					} else {
						this.$router.push({
							name: "signin",
							query: {
								redirect: this.$router.currentRoute.fullPath,
							},
						});
					}
				} else {
					this.$router.push({
						name: "signin",
						query: {
							redirect: this.$router.currentRoute.fullPath,
						},
					});
				}
			},
			// 弹出视频
			videoShow() {
				this.video_show = !this.video_show;
				this.autoplay = true;
			},
			scoreTab(index) {
				if (this.score != index) {
					this.score = index;
				}
				this.page = 1;
				this.commentList();
			},
			childTreeFn() {
				this.$refs.searnum.cartnumapi();
			},
			shopgoodsapi() {
				this.$loading();
				this.datatype = false;
				let data = {
					id: this.id,
				};
				this.$api.integralDetail(data).then((res) => {
					if (res.code == 0) {
						this.$loading().close();
						this.ttshop_goodsxinxi = res.data.goods;
						this.look_and_see = res.data.cat_goods_list;
						this.best_goods_list = res.data.goods_list;
						this.attr_group_list = res.data.attr_group_list;
						if (!this.ttshop_goodsxinxi.cover_pic && res.data.goods_pic_list[0]) {
							this.ttshop_goodsxinxi.cover_pic = res.data.goods_pic_list[0]
						}
						this.ttshop_kucun = res.data.goods.attr;

						this.datatype = true;
						setTimeout(function() {
							// 商品图片轮播
							new Swiper(".goods-img", {
								loop: false,
								slidesPerView: 5,
								spaceBetween: 8,
								observer: true,
								observeParents: true,
								navigation: {
									nextEl: ".btn-r ",
									prevEl: ".btn-l",
								},
							});
							// 看了又看
							new Swiper(".goods-look", {
								slidesPerView: 3,
								spaceBetween: 24,
								direction: "vertical",
								navigation: {
									nextEl: ".btn-bottom",
									prevEl: ".btn-top",
								},
							});
						}, 500);
						this.singleAttr();
					}
				}).catch((err) => {
					let that = this;
					this.common.message(this, err, function() {
						setTimeout(() => {
							that.$router.go(-1);
						}, 1000)
					});
				});
			},
			// 评价预览
			commentList() {
				let data = {
					goods_id: this.id,
					type: 'IN',
					page: this.page,
					limit: this.limit,
				};
				if (this.score != 0) {
					data.score = this.score;
				}
				this.$api.commentList(data).then((res) => {
					this.evaluateList = res.data.list;
					this.evaluateTab = res.data.comment_count;
					this.page_count = res.data.page_count;
					this.row_count = res.data.row_count;
				}).catch((err) => {
					console.log(err);
				});
			},
			handleCurrentChange(e) {
				this.page = e;
				this.common.backTop();
				this.commentList();
			},
			// 分页上一页
			pages_perv() {
				this.page--;
				this.common.backTop();
				this.commentList();
			},
			// 分页下一页
			page_next() {
				this.page++;
				this.common.backTop();
				this.commentList();
			},
			// 商品小图片移入事件
			enters(src) {
				this.ttshop_goodsxinxi.cover_pic = src;
			},
			// 分类
			detailsClick(e) {
				this.detailsIndex = e;
			},
			// 单属性自动选择
			singleAttr() {
				let that = this;
				let attr_group_list = that.attr_group_list;
				for (let i in attr_group_list) {
					for (let j in attr_group_list[i].attr_list) {
						that.$set(attr_group_list[i].attr_list[j], "active", false);
						that.$set(attr_group_list[i].attr_list[j], "attr_num_0", false);
					}
					if (attr_group_list[i].attr_list.length <= 1) {
						that.sizeClick(
							attr_group_list[i].attr_group_id,
							attr_group_list[i].attr_list[0].attr_id
						);
					}
				}
			},
			// 属性尺码
			sizeClick(groupid, attrid) {
				let attr_group = this.attr_group_list; //商品总属性
				let attr_group_id = groupid; //属性组id
				let attr_id = attrid; //属性id
				let ativerattr = [];
				let attr = this.ttshop_kucun; //属性库存
				for (var i in attr_group) {
					if (attr_group[i].attr_group_id == attr_group_id) {
						for (var j in attr_group[i].attr_list) {
							// attr_group[i].attr_list[j].active =
							// attr_group[i].attr_list[j].attr_id == attr_id ? true : false;
							attr_group[i].attr_list[j].active =
								attr_group[i].attr_list[j].attr_id == attr_id ?
								!attr_group[i].attr_list[j].active :
								false;
						}
					}
				}
				for (var i in attr_group) {
					for (var j in attr_group[i].attr_list) {
						if (attr_group[i].attr_list[j].active) {
							ativerattr.push(attr_group[i].attr_list[j].attr_id);
						}
					}
				}
				var u = [],
					goods_attr_info = null;
				for (var n in attr) {
					var c = [],
						_ = 0;
					for (var d in attr[n].attr_list) {
						this.inArray(attr[n].attr_list[d].attr_id, ativerattr) || (_ += 1),
							c.push(attr[n].attr_list[d].attr_id);
					}
					0 === attr[n].num && _ <= 1 && u.push(c);
					if (ativerattr.toString() == c.toString()) {
						goods_attr_info = attr[n];
					}
				}
				var g = ativerattr.length,
					l = [];
				if (attr_group.length - g <= 1)
					for (var n in ativerattr)
						for (var d in u)
							if (this.inArray(ativerattr[n], u[d]))
								for (var f in u[d]) u[d][f] !== ativerattr[n] && l.push(u[d][f]);
				for (var n in attr_group)
					for (var d in attr_group[n].attr_list) {
						var m = attr_group[n].attr_list[d];
						this.inArray(m.attr_id, l) && !this.inArray(m.attr_id, ativerattr) ?
							(m.attr_num_0 = !0) :
							(m.attr_num_0 = !1);
					}

				this.check_attr_length = g;
				if (g == attr_group.length && goods_attr_info) {
					let goods_attr_name = "";
					for (let i in goods_attr_info.attr_list) {
						goods_attr_name += goods_attr_info.attr_list[i].attr_name + ";";
					}
					this.goods_attr_info = goods_attr_info;
					this.ttshop_kcnum = Number(goods_attr_info.num); //商品总库存
					this.goods_attr_name = goods_attr_name.substring(0, goods_attr_name.length - 1);
					if (goods_attr_info.pic) {
						this.ttshop_goodsxinxi.cover_pic = goods_attr_info.pic;
					}
				}
			},
			inArray: function(e, t) {
				return t.some(function(t) {
					return e === t;
				});
			},
			// 立即兑换
			goodsSubmit() {
				let attr_group = this.attr_group_list;
				let goods_num = this.goods_attr_info.num; //选择商品的库存
				if (this.check_attr_length != attr_group.length) {
					this.$message({
						showClose: true,
						message: "请选择商品属性",
						type: "warning",
						offset: 200,
						duration: 1000,
					});
					return false;
				}
				let attr = [];
				for (let i in attr_group) {
					for (let j in attr_group[i].attr_list) {
						if (attr_group[i].attr_list[j].active) {
							attr.push({
								attr_group_id: attr_group[i].attr_group_id,
								attr_id: attr_group[i].attr_list[j].attr_id,
								attr_name: attr_group[i].attr_list[j].attr_name,
							});
						}
					}
				}
				if (goods_num < this.num) {
					this.$message({
						showClose: true,
						message: "商品库存不足",
						type: "warning",
						offset: 200,
						duration: 1000,
					});
					return false;
				}

				let data = {
					goods_id: this.ttshop_goodsxinxi.id,
					attr: attr
				}
				if (this.$store.state.user) {
					if (this.$store.state.user.token != "") {
						this.$store.commit("submitOrderRarams", JSON.stringify(data));
						this.$router.push({
							name: "integral_submit_order",
						});
					} else {
						this.$router.push({
							name: "signin",
							query: {
								redirect: this.$router.currentRoute.fullPath,
							},
						});
					}
				} else {
					this.$router.push({
						name: "signin",
						query: {
							redirect: this.$router.currentRoute.fullPath,
						},
					});
				}
			},
			// 点击相关推荐
			toGoods(id) {
				let url = this.$router.resolve({
					path: "/integral_details",
					query: {
						id: id
					}
				})
				window.open(url.href);
			},
			//优惠券
			couponTab(index) {
				this.couponIndex = index;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.details_active {
		border-top: 2px solid #ff0e25;
		background-color: #fff;
		color: #ff0e25;
	}

	.hot_active {
		border-top: 2px solid #ff0e25;
		background-color: #fff;
		color: #ff0e25;
	}

	.size_active {
		border-color: #ff0e25 !important;
	}

	.coupon_active {
		border-color: #ff0e25 !important;
		color: #ff0e25 !important;
	}

	.bannershoper {
		width: 100%;
		height: 120px;
		background-color: #ccc;
	}

	// 面包屑
	.crumb {
		width: 100%;
		height: 40px;
		background-color: #fafafa;

		.nav {
			height: 40px;

			.nav-item {
				color: #999999;
			}

			.nav-img {
				height: 12px;
				width: 12px;
			}

			.nav-items {
				height: 24px;
				position: relative;
				overflow: hidden;
				background-color: #fff;
				transition: 0.3s;

				&:hover {
					overflow: visible;

					dt {
						border-color: #ff0e25;
						border-bottom-color: #fff;
						z-index: 41;
						border-radius: 3px 3px 0 0;
					}

					dd {
						z-index: 40;
						border: 1px solid #ff0e25;
					}
				}

				dt {
					padding: 0px 4px 0px 8px;
					// line-height: 22px;
					height: 24px;
					border: 1px solid #ebebeb;
					position: relative;
					box-sizing: border-box;
					border-radius: 3px;
					background-color: #fff;
					z-index: 200;
				}

				.nav-xia {
					height: 12px;
					width: 12px;
					margin-left: 8px;
				}

				dd {
					width: 304px;
					padding: 6px 8px 10px 10px;
					position: absolute;
					top: 23px;
					left: 0;
					background-color: #fff;
					line-height: 24px;

					div {
						width: 96px;
					}
				}
			}

			.nav-option {
				padding: 0px 4px 0px 8px;
				height: 24px;
				border: 1px solid #ebebeb;
				box-sizing: border-box;
				border-radius: 3px;
				border: 1px solid #ebebeb;
				background-color: #fafafa;
				margin-right: 8px;

				span {
					color: #ff0e25;
				}

				.nav-del {
					height: 12px;
					width: 12px;
					margin-left: 8px;
				}
			}
		}
	}

	.content {
		margin-top: 24px;
	}

	// 商品属性
	.goods {
		.zntj {
			width: 100%;
			padding: 40px 10px;
			box-sizing: border-box;

			img {
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 14px;
				color: #333;
				text-align: center;
			}
		}

		.goods-l {
			width: 408px;

			.img {
				position: relative;
				height: 408px;
				width: 408px;

				.video-btn {
					cursor: pointer;
					width: 50px;
					height: 50px;
					position: absolute;
					bottom: 50px;
					left: 50%;
					margin-left: -25px;
					background-image: url('../../assets/images/main_circles.png');
					z-index: 1;
					border-radius: 50%;
				}

				.video-btn:hover {
					background-position: 50px 0;
				}

				.goods-video {
					outline: none;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 2;
					width: 100%;
					height: 100%;
					background: #000;
				}

				.video-close {
					cursor: pointer;
					position: absolute;
					z-index: 3;
					font-size: 18px;
					color: #ccc;
					top: 10px;
					right: 15px;
				}
			}

			.img-list {
				width: 408px;
				margin-top: 12px;
				height: 60px;
				padding: 0 38px;
				box-sizing: border-box;
				position: relative;

				.btn-l {
					width: 12px;
					height: 20px;
					background-image: none;
					right: 9px;
					outline: none;
					margin-top: -10px;
				}

				.goods-img {
					width: 408px;
					height: 60px;

					.img-item {
						height: 60px;
						width: 60px !important;
						border: 2px solid transparent;
						box-sizing: border-box;
						margin-right: 8px;
						cursor: pointer;

						img {
							width: 56px;
							height: 56px;
							object-fit: cover;
							display: block;
						}

						&:hover {
							border-color: #ff0e25;
						}
					}
				}

				.btn-r {
					width: 12px;
					height: 20px;
					background-image: none;
					right: 9px;
					outline: none;
					margin-top: -10px;
				}
			}

			.goods-l-btn {
				margin-top: 28px;

				.item {
					cursor: pointer;
					color: #666666;
					margin-right: 20px;

					i {
						font-size: 16px;
						margin-right: 2px;
					}

					.item-img {
						width: 12px;
						height: 12px;
						background: rgba(204, 204, 204, 1);
						margin-right: 4px;
					}
				}
			}
		}

		.goods-c {
			width: 550px;
			padding-bottom: 57px;
			box-sizing: border-box;

			.name {
				font-size: 16px;
				font-weight: 600;
			}

			.name-item {
				margin-top: 8px;
				font-size: 14px;
				color: #ff0e25;
			}

			.pic {
				width: 550px;
				height: 94px;
				background: #fafafa;
				margin-top: 24px;
				padding-left: 12px;
				border: 1px solid transparent;
				box-sizing: border-box;

				.pic-top {
					margin-top: 16px;
					color: #666666;

					del {
						margin-left: 24px;
						color: #666666;
						text-decoration: line-through;
					}
				}

				.pic-bottom {
					color: #666666;
					margin-top: 12px;

					>span {
						font-size: 16px;
						font-weight: 400;
						color: #D8D8D8;
						line-height: 30px;
						padding: 0 6px;
					}

					p {
						font-size: 30px;
						line-height: 30px;
						color: #ff4300;
					}

					.integral-price {
						font-weight: bold;
						margin-left: 24px;

						span {
							font-size: 12px;
							font-weight: 400;
							color: #999999;
							margin-left: 4px;
						}
					}

					.price {
						font-weight: bold;

						span {
							margin-right: 2px;
							color: #ff4300;
							font-size: 16px;
						}
					}
				}
			}

			// 优惠券
			.coupon {
				margin-top: 20px;

				.coupon-name {
					width: 76px;
					color: #666666;
					padding-left: 12px;
					box-sizing: border-box;
				}

				.coupon-list {
					.item {
						height: 20px;
						margin-right: 8px;
						cursor: pointer;

						.item-l {
							width: 32px;
							background-image: url(../../assets/images/coupon_item.png);
							background-repeat: no-repeat;
							color: #fff;
						}

						.item-r {
							width: 68px;
							background-color: #fff0f1;
							color: #ff0e25;
						}
					}
				}

				.coupon-btn {
					font-size: 12px;
					color: #0e9cff;
					cursor: pointer;
				}
			}

			// 促销
			.rush {
				margin-top: 16px;

				.rush-name {
					width: 76px;
					color: #666666;
					padding-left: 12px;
					box-sizing: border-box;
					margin-bottom: 6px;
				}

				.rush-list {
					.item {
						min-width: 40px;
						height: 20px;
						border-radius: 2px;
						border: 1px solid #ff0e25;
						color: #ff0e25;
						margin: 0 8px 6px 0;
						padding: 0 8px;
						box-sizing: border-box;
					}
				}
			}

			// 尺码
			.size {
				margin-top: 16px;

				.size-name {
					width: 76px;
					color: #666666;
					padding-left: 12px;
					box-sizing: border-box;
				}

				.size-list {
					.items {
						cursor: no-drop;
						min-width: 35px;
						height: 34px;
						border-radius: 2px;
						border: 1px dashed #ccc;
						margin-right: 8px;
						padding: 0 12px;
						box-sizing: border-box;
						position: relative;
						margin-bottom: 5px;
						opacity: 0.8;
					}

					.item {
						cursor: pointer;
						min-width: 35px;
						height: 34px;
						border-radius: 2px;
						border: 1px solid #ebebeb;
						margin-right: 8px;
						padding: 0 12px;
						box-sizing: border-box;
						position: relative;
						margin-bottom: 5px;

						.pitc {
							position: absolute;
							bottom: 0;
							right: 0;
							height: 12px;
							width: 12px;
						}

						&:hover {
							border-color: #ff0e25;
						}
					}
				}
			}

			// 按钮
			.btn {
				margin-top: 24px;
				margin-left: 76px;

				.btn-buy {
					cursor: pointer;
					width: 112px;
					height: 40px;
					background: #ff0e25;
					border-radius: 2px;
					color: #fff;
					font-size: 16px;
					font-weight: 500;
				}

				.btn-cat {
					cursor: pointer;
					margin-left: 8px;
					width: 148px;
					height: 40px;
					background: rgba(255, 144, 16, 1);
					border-radius: 2px;
					font-weight: 500;
					font-size: 16px;
					color: #fff;

					.btn-cat-img {
						height: 16px;
						width: 16px;
						margin-right: 4px;
					}
				}

				.btn-phone {
					margin-left: 8px;
					width: 126px;
					height: 40px;
					border: 1px solid #ebebeb;
					border-radius: 2px;
					font-weight: 500;
					font-size: 12px;
					color: #666666;
					position: relative;
					box-sizing: border-box;
					overflow: hidden;
					cursor: pointer;

					&:hover {
						overflow: visible;
					}

					.btn-phone-l {
						height: 16px;
						width: 16px;
						background-color: #cccccc;
						margin-right: 8px;
					}

					.btn-phone-r {
						height: 14px;
						width: 14px;
						margin-left: 20px;
					}

					.btn-phone-qr {
						width: 126px;
						height: 114px;
						border: 1px solid #ebebeb;
						background-color: #fff;
						position: absolute;
						left: -1px;
						top: 38px;
						box-sizing: border-box;
						padding: 0 12px;
						border-top-color: #fff;

						.btn-phone-img {
							height: 102px;
							width: 102px;
							background-color: #ccc;
						}
					}
				}
			}
		}

		.goods-r {
			width: 199px;
			height: 571px;
			padding-bottom: 55px;
			padding-left: 35px;
			box-sizing: border-box;
			border-left: 1px solid #ebebeb;
			position: relative;
			border-bottom: 1px solid transparent;

			.title {
				color: #666666;
				margin-top: 12px;

				.txt {
					margin: 0 8px;
				}

				span {
					width: 38px;
					height: 1px;
					background: #ebebeb;
					display: inline-block;
				}
			}

			.list {
				height: 468px;
				margin-top: 24px;
				overflow: hidden;

				.item {
					cursor: pointer;
					height: 140px;
					width: 140px;
					position: relative;
					margin-bottom: 24px;
				}

				.pic {
					width: 140px;
					height: 24px;
					position: absolute;
					bottom: 0;
					left: 0;
					background: #fff;
					opacity: 0.8;
				}
			}

			.btn {
				width: 140px;
				margin-top: 24px;

				.btn-top {
					height: 20px;
					width: 12px;
					margin-right: 16px;
					background-image: none;
					left: 77px;
					outline: none;
					top: 100%;
					transform: rotate(90deg);
					-ms-transform: rotate(90deg);
					-moz-transform: rotate(90deg);
					-webkit-transform: rotate(90deg);
					-o-transform: rotate(90deg);
				}

				.btn-bottom {
					height: 20px;
					width: 12px;
					background-image: none;
					right: 66px;
					outline: none;
					top: 100%;
					transform: rotate(-90deg);
					-ms-transform: rotate(-90deg);
					-moz-transform: rotate(-90deg);
					-webkit-transform: rotate(-90deg);
					-o-transform: rotate(-90deg);
				}
			}
		}
	}

	//热销模块
	.hot {
		width: 100%;
		border: 1px solid #ebebeb;
		box-sizing: border-box;

		.hot-tab {
			height: 32px;
			background-color: #fafafa;

			.tab-item {
				cursor: pointer;
				text-align: center;
				min-width: 100px;
				height: 32px;
				line-height: 32px;
				padding: 0 26px;
				box-sizing: border-box;
			}
		}
	}

	// 商品详情
	.details {
		margin-top: 21px;

		.details-l {
			width: 190px;

			.shop {
				width: 190px;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				.shop-title {
					height: 32px;
					width: 100%;
					background-color: #fafafa;
					padding: 0 12px;
					box-sizing: border-box;

					.title-l {
						font-size: 14px;
						color: #666666;
					}

					.title-r {
						.img-l {
							height: 12px;
							width: 12px;
						}

						.img-c {
							color: #666666;
							margin: 0 4px;
						}

						.img-r {
							height: 14px;
							width: 14px;
						}
					}
				}

				.shop-name {
					padding: 0 12px;
					box-sizing: border-box;
					margin-top: 24px;
					color: #666666;
				}

				.shop-tel {
					padding: 0 12px;
					box-sizing: border-box;
					margin-top: 16px;
					color: #666666;
				}

				.shop-kf {
					cursor: pointer;
					padding: 0 12px;
					box-sizing: border-box;
					margin-top: 16px;
					color: #666666;

					.kf-img {
						height: 12px;
						width: 12px;
						margin-right: 4px;
					}
				}

				.btn {
					padding: 0 12px;
					box-sizing: border-box;
					margin: 24px 0 10px;

					.btn-l {
						width: 75px;
						height: 28px;
						border-radius: 2px;
						border: 1px solid #ff0e25;
						box-sizing: border-box;
						color: #ff0e25;
						outline: none;
						cursor: pointer;
					}

					.btn-r {
						width: 75px;
						height: 28px;
						border-radius: 2px;
						border: 1px solid #ff9010;
						box-sizing: border-box;
						color: #ff9010;
						outline: none;
						cursor: pointer;
					}
				}
			}

			.goods {
				margin-top: 17px;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				.goods-title {
					height: 32px;
					background-color: #fafafa;
					font-size: 14px;
					color: #666666;
					padding-left: 12px;
					box-sizing: border-box;
					line-height: 32px;
				}

				.goods-list {
					padding: 20px 25px 0 25px;
					box-sizing: border-box;

					.goods-item {
						margin-bottom: 20px;
						cursor: pointer;

						.item-img {
							height: 140px;
							width: 140px;
							background-color: #cccccc;

							img {
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.item-name {
							line-height: 18px;
							height: 36px;
							overflow: hidden;
							color: #666666;
							margin-top: 16px;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
						}

						.item-pic {
							margin-top: 12px;
							color: #ff4300;
						}

						&:hover .item-name {
							color: #ff0e25;
						}
					}
				}
			}
		}

		.details-r {
			width: 990px;

			.details-r-box {
				width: 100%;
				// padding-bottom: 50px;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				.tab {
					height: 46px;
					background-color: #fafafa;

					.tab-item {
						height: 46px;
						padding: 0 24px;
						line-height: 46px;
						box-sizing: border-box;
						cursor: pointer;
					}

					.tab-active {
						background-color: #fff;
						border-top: 2px solid #ff0e25;
					}

					.mobile {
						height: 46px;
						box-sizing: border-box;
						width: 118px;
						margin-left: auto;
						box-sizing: border-box;
						border: 1px solid transparent;
						padding: 0 12px;
						overflow: hidden;
						position: relative;

						&:hover {
							overflow: visible;
							border-color: #ebebeb;
							background-color: #fff;
						}

						.mobile-l {
							height: 16px;
							width: 16px;
							background-color: #ccc;
						}

						.mobile-c {
							margin: 0 7px;
							color: #666666;
						}

						.mobile-r {
							height: 14px;
							width: 14px;
						}

						.mobile-hidden {
							width: 118px;
							height: 104px;
							position: absolute;
							left: -1px;
							top: 44px;
							border: 1px solid #ebebeb;
							border-top-color: #fff;
							background-color: #fff;
							padding: 0 12px;
							box-sizing: border-box;

							.mobile-hidden-img {
								width: 94px;
								height: 94px;
								background-color: #cccccc;
							}
						}
					}

					.btn {
						cursor: pointer;
						width: 126px;
						height: 46px;
						background: #ff9010;
						font-weight: 500;
						font-size: 16px;
						color: #fff;
						line-height: 46px;
						text-align: center;
						// margin-left: auto;
						margin-left: 12px;
					}
				}

				// 详情
				.conter {
					padding: 0 24px;
					box-sizing: border-box;

					.parameter {
						padding: 32px 0;
						box-sizing: border-box;
						border-bottom: 1px dashed #e6e6e6;

						.parameter-title {
							color: #666666;
							font-weight: 600;
						}

						.parameter-list {
							margin-top: 16px;

							.parameter-item {
								width: 240px;
								display: inline-block;
								color: #666666;
								margin-bottom: 4px;
							}
						}
					}

					.conter-img {
						width: 800px;
						margin: 0 auto;
						margin-top: 40px;
						margin-bottom: 50px;
					}
				}

				//评价
				.evaluate {
					padding: 0 24px;
					box-sizing: border-box;

					.evaluate-tab {
						height: 142px;
						padding: 0 24px;
						border-bottom: 1px dashed #e6e6e6;
						box-sizing: border-box;

						.evaluate-num {
							.num {
								font-size: 40px;
								font-weight: bold;
								color: #ff4300;

								span {
									font-size: 20px;
									color: #ff4300;
								}
							}

							.txt {
								font-size: 14px;
								color: #666666;
								margin-top: 5px;
							}
						}

						.tab-list {
							margin-left: 64px;

							.tab-item {
								padding: 0 24px;
								min-width: 100px;
								height: 32px;
								background: #fff0f1;
								border-radius: 16px;
								border: 1px solid #ff3346;
								font-size: 14px;
								color: #ff4300;
								text-align: center;
								line-height: 32px;
								box-sizing: border-box;
								margin-right: 16px;
								cursor: pointer;
							}

							.tab_item_avtive {
								background-color: #ff0e25;
								border: 0 none;
								color: #fff;
							}
						}
					}

					.evaluate-item {
						padding: 24px 0;
						box-sizing: border-box;
						border-bottom: 1px solid #ebebeb;

						&:last-child {
							border: 0;
						}

						.user-l {
							width: 199px;

							.user-img {
								width: 40px;
								height: 40px;
								border-radius: 40px;
							}

							.user-name {
								color: #999999;
								margin-left: 14px;
							}
						}

						.evaluate-item-r {
							.star-list {
								.star-img {
									height: 14px;
									width: 14px;
									margin-right: 2px;
								}
							}

							.txt {
								width: 742px;
								margin-top: 9px;
								line-height: 18px;
							}

							.img-list {
								margin-top: 16px;

								.img {
									width: 60px;
									height: 60px;
									margin-right: 4px;
									// background-color: #cccccc;
								}
							}

							.time {
								margin-top: 16px;
								color: #999999;
							}
						}
					}
				}
			}

			.details-r-box:last-child {
				margin-bottom: 42px;
			}

			.page {
				// margin-left: auto;
				margin-top: 25px;
			}

			// 其他商品
			.rest-title {
				width: 990px;
				height: 32px;
				background-color: #fafafa;
				line-height: 32px;
				padding-left: 26px;
				box-sizing: border-box;
				margin-top: 42px;
			}

			//商品列表
			.rest-list {
				width: 990px;
				margin-top: 16px;

				.rest-item {
					width: 246px;
					height: 334px;
					background-color: #ffffff;
					padding: 16px 12px;
					box-sizing: border-box;
					margin-bottom: 20px;
					margin-right: 2px;
					cursor: pointer;

					&:hover {
						box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
					}

					&:nth-child(4n) {
						margin-right: 0;
					}

					.rest-img {
						height: 222px;
						width: 222px;
						background-color: #cccccc;
					}

					.rest-name {
						height: 36px;
						color: #666666;
						overflow: hidden;
						line-height: 18px;
					}

					.rest-pic {
						.pic-l {
							font-weight: bold;
							font-size: 20px;
							color: #ff4300;

							span {
								font-size: 16px;
								color: #ff4300;
							}
						}

						.pic-r {
							color: #999999;

							span {
								color: #0e9cff;
								margin-right: 4px;
							}
						}
					}
				}
			}
		}
	}

	//优惠券弹窗
	.coupon-tab {
		font-size: 32px;

		.coupon-tab-item {
			color: #666666;
			padding-bottom: 8px;
			box-sizing: border-box;
			border-bottom: 2px solid transparent;
			margin-right: 26px;
			cursor: pointer;
		}
	}
</style>
